<style lang="scss" scoped>
.box-columns {
  column-gap: 2rem;
  orphans: 1;
  widows: 1;
}
@media (min-width: 576px) {
  .box-columns {
    column-count: 2;
  }
}
@media (min-width: 768px) {
  .box-columns {
    column-count: 3;
  }
}
@media (min-width: 1440px) {
  .box-columns {
    column-count: 4;
  }
}
.box-columns .box {
  margin-bottom: 3rem;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
@media (min-width: 576px) {
  .box-columns .box {
    display: inline-block;
    width: 100%;
  }
}
.insta-box {
  .box-body {
    padding: 0;
  }
  .image {
    width: 100%;
  }
  .caption {
    padding: 15px 20px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    float: left;
    margin-right: 6px;
  }
  .name {
    font-weight: 600;
    display: inline-block;
    margin-top: 2px;
    font-size: 14px;
  }
  .location,
  .tags {
    font-size: 12px;
  }
  .post-status {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>

<template>
  <div id="campaign-brief">
    <section class="content box-columns">
      <div class="box insta-box" v-for="post in posts" :key="post.id">
        <div class="box-header with-border">
          <img class="avatar" :src="post.influencer.instagram.profilePicture">
          <span class="name">{{ post.influencer.fullName }}</span>
          <div class="location">{{ post.location }}</div>
          <div class="tags">Tags: {{ post.hashtag }}</div>
          <span class="label label-default post-status">{{ post.status | postStatusText }}</span>
        </div>
        <div class="box-body">
          <img v-if="post.imageURL" class="image" :src="post.imageURL">
          <p class="text-center" style="padding-top:10px">No image</p>
          <div class="caption">
            {{ post.description }}
          </div>
        </div>
        <div class="box-footer">
          <button class="btn btn-primary btn-sm" v-if="canApprove(post.status)" @click.prevent="approvePost(post)">Approve Post</button>
        </div>
      </div>
    </section>

    <!-- <view-campaign-modal :modalId="'view_campaign_modal'" :campaignData="viewCampaignData" /> -->
  </div>
</template>

<script>
import moment from 'moment'
import campaignAPIs from './campaignAPIs'
import campaignConfig from './config'
import ViewCampaignModal from './ViewCampaignModal'

export default {
  name: 'influencer-posts',
  components: {
    ViewCampaignModal
  },
  data() {
    return {
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      posts: [],
      keyword: '',
      fields: [
        {
          key: 'pairingStatusDisplay',
          label: 'Status'
        },
        {
          key: 'name'
        },
        {
          key: 'goal'
        },
        {
          key: 'budget'
        },
        {
          key: 'updatedAt'
        },
        {
          key: 'actions'
        }
      ],
      viewCampaignData: null
    }
  },
  created() {
    this.fetchPosts()
  },
  filters: {
    postStatusText(value) {
      return campaignConfig.postStatusDisplay[value] ? campaignConfig.postStatusDisplay[value] : ''
    }
  },
  methods: {
    canApprove(status) {
      return status === campaignConfig.postStatus.DRAFT || status === campaignConfig.postStatus.CLIENT_PENDING
    },
    fetchPosts() {
      campaignAPIs
        .getPostsForClient(this.$store.state.user.clientID)
        .then(response => {
          this.posts = response
        })
        .catch(err => {
          console.log(err)
        })
    },

    getCampaignDataToView(campaignID) {
      campaignAPIs
        .getCampaign(campaignID)
        .then(response => {
          this.viewCampaignData = response
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss')
    },
    approvePost(post) {
      campaignAPIs
        .approvePost(post.id, post.status)
        .then(response => {
          this.fetchPosts()
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// InfluencerPosts.vue?66770805